import * as React from "react";
import { Loader } from "semantic-ui-react";

import { QuestionnaireConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { PhysiotherapyReferralFormProps } from "../models";

interface OwnProps {
    readonly: boolean;
    questionnaireConfig: QuestionnaireConfig;
    afterSubmit?: (ohCaseId: string) => void;
    loadOrgStructure: (parentOrgStructureLevelId: string) => void;
    physiotherapyReferralFormComponent: React.ComponentType<PhysiotherapyReferralFormProps>;
    api?: string;
    linkedOhCaseId?: string;
    applicationType?: string;
    documentBaseApi: string;
}

const PhysiotherapyForm: React.FunctionComponent<OwnProps> = (props: OwnProps) => {

    const PhysiotherapyReferralFormComponent = props.physiotherapyReferralFormComponent;

    if (!props.questionnaireConfig) {
        return <Loader active />;
    }

    return (
        <PhysiotherapyReferralFormComponent
            readonly={props.readonly}
            questionnaireConfig={props.questionnaireConfig}
            afterSubmit={props.afterSubmit}
            loadOrgStructure={props.loadOrgStructure}
            api={props.api}
            linkedOhCaseId={props.linkedOhCaseId}
            documentBaseApi={props.documentBaseApi}
        />
    );
};

export { PhysiotherapyForm };
